import IconButton from '@mui/material/IconButton'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import type { GridColDef } from '@mui/x-data-grid-premium'

import ResourceDisplay from '../../../components/resource'
import { Resource } from '../../../../../../graphql'
import { PolicyRow } from './index'

export default function createColumns( onRemovePolicyClick: ( policy: PolicyRow ) => void ): GridColDef<PolicyRow>[] {
	return [
		{
			field: 'roleName',
			headerName: 'Role',
			width: 200,
			valueGetter: ( _value, row ) => row.role.name,
		},
		{
			field: 'resource',
			headerName: 'Resource Applied To',
			width: 200,
			renderCell: ( params ) => <ResourceDisplay resource={params.row.resource as Resource} />,
		},
		{
			field: 'actions',
			headerName: '',
			width: 96,
			align: 'center',
			headerAlign: 'center',
			renderCell: ( params ) => (
				<IconButton
					size="small"
					aria-label="Remove"
					title="Remove policy"
					onClick={() => onRemovePolicyClick( params.row )}
				>
					<DeleteOutlineIcon fontSize="small" />
				</IconButton>
			),
		},
	]
}
